<template>
    <div class="text-xs-center pa-4" style="max-height: calc(100vh - 100px); overflow: auto">
        <v-dialog v-model="openMemberDialog" fullscreen transition="dialog-right-transition" persistent
                  @keydown.esc="cancelMemberDialog">
            <v-form v-model="valid" lazy-validation ref="form">

                <v-card class="elc-addmember-card">

                    <div style="height: calc(100vh - 50px);overflow-y: auto;">
                        <v-container grid-list-md>

                            <div style="position:relative;">
                                <h2 class="p-10" v-if="!addEditFlag">Add Member </h2>
                                <h2 class="p-10" v-if="addEditFlag && !reqFlag">Update Member </h2>
                                <h2 class="p-10" v-if="addEditFlag && reqFlag">Add Member </h2>

                                <v-tooltip bottom style="position:absolute;top: 0;right: 0;">

                                    <v-btn slot="activator" icon @click="cancelMemberDialog">
                                        <v-icon>clear</v-icon>
                                    </v-btn>

                                    <span>Close</span>

                                </v-tooltip>

                            </div>

                            <v-layout wrap>

                                <v-flex xs12 md3 class="p-10">
                                    <v-select :items="constant.namePrefix" v-model="member.prefix" label="Prefix"
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="member.fname" :rules="fieldRules" label="First Name*"
                                                  required @keypress="isAlphaNumeric"></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="member.mname" label="Middle Name"
                                                  required @keypress="isAlphaNumeric"></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="member.lname" :rules="fieldRules" label="Last Name*"
                                                  required @keypress="isAlphaNumeric"></v-text-field>
                                </v-flex>

                            </v-layout>


                            <v-layout wrap>
                                <v-flex xs12 md4 class="p-10">

                                    <v-menu
                                            ref="menu"
                                            :close-on-content-click="false"
                                            v-model="menu"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"

                                    >
                                        <v-text-field slot="activator" v-model="member.dob" label="DOB"
                                                      prepend-icon="event" readonly
                                                      @click="dob = parseDate(member.dob)"
                                        ></v-text-field>

                                        <v-date-picker ref="picker" no-title v-model="dob" @input="menu = false"
                                                       :max="'2015-12-31'"></v-date-picker>

                                    </v-menu>

                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="member.election_id" label="Election ID"
                                                  :rules="elecIdRules" :mask="maskAlphaNum"
                                    ></v-text-field>
                                </v-flex>


                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 md4 class="p-10">
                                    <v-text-field v-model="member.email"
                                                  label="Email"></v-text-field>
                                </v-flex>

                                <v-flex xs2 md1 class="p-10">
                                    <v-text-field label="+91" disabled></v-text-field>
                                </v-flex>

                                <v-flex xs10 md3 class="p-10">
                                    <v-text-field v-model="member.primary_mobile" :mask="mask"
                                                  :rules="fieldRules" label="Primary Contact*"></v-text-field>
                                </v-flex>

                                <v-flex xs2 md1 class="p-10">
                                    <v-text-field label="+91" disabled></v-text-field>
                                </v-flex>

                                <v-flex xs10 md3 class="p-10">
                                    <v-text-field v-model="member.secondary_mobile" :mask="mask"
                                                  label="Secondary Contact"></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="p-10 text-sm-right">
                                    <v-btn class="elc-button-radius" @click="cancelMemberDialog">Cancel</v-btn>
                                    <v-btn class="elc-button-radius-color" v-if="!addEditFlag" @click="addNewMember"
                                           :disabled="member.fname == '' ||member.lname == '' ||member.primary_mobile == '' || !valid"
                                    >Save
                                    </v-btn>
                                    <v-btn class="elc-button-radius-color" v-if="addEditFlag && !reqFlag"
                                           @click="updateNewMember" :disabled="!valid"
                                    >Update
                                    </v-btn>
                                    <v-btn class="elc-button-radius-color" v-if="addEditFlag && reqFlag"
                                           @click="updateNewMember"
                                           :disabled="member.fname == '' ||member.lname == '' ||member.primary_mobile == '' || !valid"
                                    >Approve
                                    </v-btn>
                                    <!-- <v-btn class="elc-button-radius-color" v-if="addEditFlag && reqFlag"
                                           @click="updateNewMember"
                                           :disabled="member.prefix == null ||member.fname == '' ||member.lname == '' ||member.dob == '' ||member.email == '' ||member.primary_mobile == '' || !valid"
                                    >Save
                                    </v-btn>-->
                                </v-flex>

                            </v-layout>


                        </v-container>

                    </div>

                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-text>{{msg}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <alert-modal :alertMsg="msg" :alertMsgDialog="alertDialog" @closeAlert="alertDialog = false"></alert-modal>
    </div>
</template>

<script>
    import Common from '../Common/Constants'
    import moment from 'moment'
    import AlertModal from '../Common/AlertModal'


    export default {
        name: "AddMember",
        components: {AlertModal},
        props: ['memberDialog', 'addEditFlag', 'editObj', 'editedObj', 'reqFlag'],
        data() {
            return {
                constant: Common,
                dialog: false,
                header: {},
                mask: '##### #####',
                maskAlphaNum: 'NNNNNNNNNN',
                valid: false,
                msg: '',
                alertDialog: false,
                nameRules: [
                    v => !!v || 'This field is required',
                    v => /.^[a-zA-Z0-9]*$/.test(v) || 'Must be alpha-numeric characters',
                    /*(v) => {
                        if (!v || v.length <= 3)
                            return 'Must be greater than 3 characters'
                        else return true;
                    },*/
                ],
                elecIdRules: [
                    // v => !!v || 'Election id is required',
                    (v) => {
                        if (v.length > 0 && v.length < 10)
                            return 'Must be 10 characters';
                        else if (v.length > 10)
                            return 'Must be 10 characters';
                        else return true;
                    },
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid'
                ],
                fieldRules: [
                    v => !!v || 'This field is required',
                ],
                rolePrefix: ['Admin', 'member'],
                member: {
                    club_id: '',
                    prefix: '', fname: '', mname: '',
                    lname: '', primary_mobile: '', secondary_mobile: '',
                    primary_country_code: '', secondary_country_code: '',
                    // primary_country_code: '+91', secondary_country_code: '+91',
                    email: '', dob: null, election_id: '',
                },
                menu: false, dob: null,
                successToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'success-toast'
                },
                errorToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'error-toast'
                },
                //    form
                openMemberDialog: false,
                addEditFlag: false,

            }
        },
        beforeDestroy() {
            console.log("*******beforeDestroy*******", this.editObj)
        },
        destroyed() {
            console.log("*******destroyed*******", this.editObj)
        },
        mounted() {
            let self = this;
            let token = localStorage.getItem('token');
            if (token === '' || token === undefined || token === null) {
                self.$router.push('/')
            }
            self.header = {
                "Content-Type": "application/json",
                "token": token,
            };
            self.openMemberDialog = this.memberDialog;
            if (self.addEditFlag) {
                self.editData();
            }
        },
        created() {
            let self = this;
            let token = localStorage.getItem('token');
            if (token === '' || token === undefined || token === null) {
                self.$router.push('/')
            }
            self.header = {
                "Content-Type": "application/json",
                "token": token,
            };
            self.openMemberDialog = this.memberDialog;
            // if (self.addEditFlag == true && self.reqFlag == true) {
            if (self.addEditFlag) {
                self.editData();
            }
        },
        methods: {
            isAlphaNumeric: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                var ret = (charCode == 32 || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122));
                if (!ret) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            editData() {
                let self = this;
                self.member = {
                    club_id: self.editObj.club_id,
                    prefix: self.editObj.prefix,
                    fname: self.editObj.fname,
                    mname: self.editObj.mname,
                    lname: self.editObj.lname,
                    primary_mobile: self.editObj.phone[0].phone,
                    secondary_mobile: self.editObj.phone.length != 0 ? self.editObj.phone[1].phone : '',
                    email: self.editObj.email,
                    dob: self.editObj.dob == 0 ? null : self.editObj.dob,
                    election_id: self.editObj.election_id,
                    member_id: self.editObj.member_id,
                };
            },
            addNewMember() {
                let self = this;
                if (this.valid) {
                    let obj = Object.assign({}, this.member);
                    obj.primary_country_code = '+91';
                    obj.secondary_country_code = '+91';
                    obj.club_id = this.$route.params.id;
                    axios.post(Common.apiUrl + 'member/create', obj, {headers: self.header})
                        .then(res => {
                            if (res.data.flag) {
                                self.$toasted.show('Member Added', self.successToast);
                                self.cancelMemberDialog();
                                self.$emit('saveMember')
                                // window.history.go(-1)
                                // self.$router.push('/MemberDetails/' + self.$route.params.id);
                            } else {
                                // self.$toasted.show(res.data.message, self.errorToast);
                                self.alertDialog = true;
                                self.msg = '';
                                self.msg = res.data.message;
                            }
                        })
                        .catch((handle) => {
                            // self.$toasted.show(handle, self.errorToast);
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = "Please fill all details";
                        })
                } else {

                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = "Please fill all details";
                }
            },
            goBack() {
                window.history.go(-1)
                // this.$router.push('/MemberDetails/' + this.$route.params.id)
            },
            updateNewMember() {
                let self = this;
                self.addEditFlag = true;
                self.editedObj = self.member;
                self.editedObj.primary_country_code = self.editObj.phone[0].countryCode;
                self.editedObj.secondary_country_code = self.editObj.phone[1].countryCode;
                self.editedObj.is_verify = (self.addEditFlag && self.reqFlag) ? 1 : self.editedObj.is_verify;
                self.$emit('updateMember', self.editedObj)
            },
            cancelMemberDialog() {
                let self = this;
                self.addEditFlag = false;
                self.openMemberDialog = false;
                self.member = {};
                self.dob = null;
                self.$refs.form.reset();
                self.$emit('closeMemberDialog');
                // self.$destroy();
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split('-');
                return `${day}-${month}-${year}`

            }
            ,
            parseDate(date) {
                if (!date) return null;
                const [day, month, year] = date.split('-');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            }
        },
        watch: {
            menu(val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            dob() {
                this.member.dob = this.formatDate(this.dob);
            }
        }
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Member/AddMember.vue